var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#335DD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 3-1.27.739L5.27 5.76 4 6.5v7l1.27.739 3.492 2.023 1.27.738 1.27-.738 3.428-2.024L16 13.5v-7l-1.27-.739-3.46-2.022L10 3Zm-3.46 9.023V7.977L10 5.954l3.46 2.023v4.046L10 14.046l-3.46-2.023Z",
    fill: "#fff"
  })));
};
export default SvgLink;